if (!customElements.get('ct-mobile-product-header')) {
  customElements.define('ct-mobile-product-header', class extends HTMLElement {
    connectedCallback() {
      this.items = new Map();
      this.media = matchMedia('(max-width: 768px)');
      this.sync = () => {
        const root = this.closest('product-component');
        const blocks = root?.querySelector('[data-product-blocks]');
        if (!blocks) return;
        if (this.media.matches) {
          const children = [...blocks.children].filter(el => !el.hasAttribute('data-ct-header-placeholder'));
          const review = children.find(el => el.querySelector('.jdgm-preview-badge') || el.matches('.jdgm-preview-badge') || el.id.includes('judge_me_reviews_preview_badge'));
          const title = children.find(el => el.matches('.ct-pdp-title'));
          for (const node of [review, title].filter(Boolean)) {
            if (this.items.has(node)) continue;
            const marker = document.createElement('span');
            marker.hidden = true;
            marker.setAttribute('data-ct-header-placeholder', '');
            if (node.matches('.ct-pdp-title')) marker.className = 'ct-pdp-title';
            node.before(marker);
            this.items.set(node, marker);
            if (node === review) this.prepend(node); else this.append(node);
          }
        } else {
          for (const [node, marker] of this.items) { marker.replaceWith(node); }
          this.items.clear();
        }
      };
      this.media.addEventListener('change', this.sync);
      this.frame = requestAnimationFrame(() => {
        this.sync();
        const gallery = this.closest('product-component')?.querySelector('.ct-pdp-gallery--flush');
        if (gallery) {
          this.updateCount = () => {
            const slider = gallery.querySelector('.product-slideshow');
            const dots = slider && [...slider.querySelectorAll('.flickity-page-dots .dot')];
            if (!slider || !dots?.length) return;
            const many = dots.length > 7;
            slider.toggleAttribute('data-ct-many-images', many);
            let counter = slider.querySelector('.ct-gallery-count');
            if (!counter && many) {
              counter = document.createElement('span');
              counter.className = 'ct-gallery-count';
              counter.setAttribute('aria-hidden', 'true');
              slider.append(counter);
            }
            if (counter) {
              counter.hidden = !many;
              const current = Math.max(0, dots.findIndex(dot => dot.classList.contains('is-selected'))) + 1;
              const text = current + ' / ' + dots.length;
              if (counter.textContent !== text) counter.textContent = text;
            }
          };
          this.updateCount();
          this.galleryObserver = new MutationObserver(this.updateCount);
          this.galleryObserver.observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        }
        const blocks = this.closest('product-component')?.querySelector('[data-product-blocks]');
        if (blocks) {
          this.observer = new MutationObserver(this.sync);
          this.observer.observe(blocks, { childList: true, subtree: true });
        }
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.media?.removeEventListener('change', this.sync);
      this.observer?.disconnect();
      this.galleryObserver?.disconnect();
      for (const [node, marker] of this.items) { if (marker.parentNode) marker.replaceWith(node); }
      this.items.clear();
    }
  });
}
